// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2OpZU","content":"styles_content__3F3UE","checkbox":"styles_checkbox__OWgkg","checkboxLabel":"styles_checkboxLabel__37Rrd"};